import { Col, Form, Row, Steps } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Button } from 'components';
import { useTitle } from 'contexts/TitleProvider';
import Content from 'layouts/Content';
import ApprovalLevels from 'pages/System/SetApprovalPage/ApprovalAdjusterPage/components/ApprovalLevels';
import Establish from 'pages/System/SetApprovalPage/ApprovalAdjusterPage/components/Establish';
import { useEffect, useState } from 'react';

const steps = [
  {
    id: '1',
    title: 'Thiết lập',
  },
  {
    id: '2',
    title: 'Người duyệt',
  },
];

const ApprovalAdjusterPage = () => {
  const [form] = useForm();
  const { setTitle, setBreadcrumb } = useTitle();
  const [step, setStep] = useState(0);
  const [, setType] = useState<string>('');
  const [level, setLevel] = useState<number>(0);

  useEffect(() => {
    setTitle('Tạo mới phê duyệt');
    setBreadcrumb([{ title: 'Hệ thống' }, { title: 'Tạo mới phê duyệt' }]);
  }, [setBreadcrumb, setTitle]);

  const handlePrev = () => {
    setStep(step - 1);
  };

  const handleNext = async () => {
    try {
      await form.validateFields();

      if (step === steps.length - 1) return handleFinish();

      if (step === 0) {
        const { type, level } = form.getFieldsValue();
        setType(type);
        setLevel(Number(level));
      }

      setStep(step + 1);
    } catch (error) {
      // console.log(error);
    }
  };
  const handleFinish = () => {
    // FIXME: Gọi API thiết lập phê duyệt
    // Nếu thiết lập phê duyệt thành công, hiển thị thông báo "Thiết lập phê duyệt thành công".
    // Nếu có lỗi trong thiết lập, hiển thị thông báo lỗi và yêu cầu sửa đổi.

    console.log('Finish');
    console.log(form.getFieldsValue());
  };

  return (
    <>
      <Steps
        className="max-w-[320px] mx-auto mt-[14px]"
        current={step}
        labelPlacement="vertical"
        items={steps}
      />
      <Form
        form={form}
        layout="vertical"
        className="flex-1 flex flex-col justify-between"
      >
        <Content className="mt-8">
          {step === 0 && <Establish />}
          {step === 1 && <ApprovalLevels level={level} />}
        </Content>
        <Row
          className="mt-auto"
          gutter={[8, 16]}
          align={'middle'}
          justify={'end'}
        >
          <Col>
            <Button
              disabled={!step}
              title="Quay lại"
              handleOnclick={handlePrev}
            />
          </Col>
          <Col>
            <Button
              fill
              type="submit"
              title={step === steps.length - 1 ? 'Tạo' : 'Tiếp theo'}
              handleOnclick={handleNext}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ApprovalAdjusterPage;
